import { Route } from "react-router-dom";
import AcctLayout from "@/features/acct/AcctLayout";
import AcctDashboardPage from "@/pages/AcctDashboardPage";
import AcctJournalPage from "@/pages/AcctJournalPage";
import AcctAccountsPage from "@/pages/AcctAccountsPage";
import AcctPeriodsPage from "@/pages/AcctPeriodsPage";
import AcctTrialBalancePage from "@/pages/AcctTrialBalancePage";
import AcctPermsPage from "@/pages/AcctPermsPage";
import AcctAuditPage from "@/pages/AcctAuditPage";
import AcctSettingsPage from "@/pages/AcctSettingsPage";
import { MANAGER_ROLES } from "@/utils/role";
import AcctCashPage from "@/pages/AcctCashPage";
import AcctBillsPage from "@/pages/AcctBillsPage";
import AcctInvoicesPage from "@/pages/AcctInvoicesPage";
import AcctPaymentsPage from "@/pages/AcctPaymentsPage";
import AcctContactsPage from "@/pages/AcctContactsPage";
import AcctTxnPage from "@/pages/AcctTxnPage";
import AcctReportsPage from "@/pages/AcctReportsPage";
import AcctExecutivePage from "@/pages/AcctExecutivePage";
import AcctProjectsPage from "@/pages/AcctProjectsPage";
import AcctStaffPayPage from "@/pages/AcctStaffPayPage";
import AcctAssetsPage from "@/pages/AcctAssetsPage";
import AcctPayrollPostPage from "@/pages/AcctPayrollPostPage";
import AcctLeasesPage from "@/pages/AcctLeasesPage";
import AcctInventoryPage from "@/pages/AcctInventoryPage";
import AcctEosPage from "@/pages/AcctEosPage";
import AcctSupplierDuesPage from "@/pages/AcctSupplierDuesPage";
import { ProtectedRoute } from "@/routes/ProtectedRoute";
import { FeatureGate } from "@/components/layout/FeatureGate";

const PAGES = [
  { path: "/accounting", element: <AcctDashboardPage /> },
  { path: "/accounting/journal", element: <AcctJournalPage /> },
  { path: "/accounting/cash", element: <AcctCashPage /> },
  { path: "/accounting/bills", element: <AcctBillsPage /> },
  { path: "/accounting/invoices", element: <AcctInvoicesPage /> },
  { path: "/accounting/payments", element: <AcctPaymentsPage /> },
  { path: "/accounting/supplier-dues", element: <AcctSupplierDuesPage /> },
  { path: "/accounting/contacts", element: <AcctContactsPage /> },
  { path: "/accounting/staff-payments", element: <AcctStaffPayPage /> },
  { path: "/accounting/projects", element: <AcctProjectsPage /> },
  { path: "/accounting/assets", element: <AcctAssetsPage /> },
  { path: "/accounting/leases", element: <AcctLeasesPage /> },
  { path: "/accounting/inventory", element: <AcctInventoryPage /> },
  { path: "/accounting/eos", element: <AcctEosPage /> },
  { path: "/accounting/payroll-posting", element: <AcctPayrollPostPage /> },
  { path: "/accounting/transactions", element: <AcctTxnPage /> },
  { path: "/accounting/reports", element: <AcctReportsPage /> },
  { path: "/accounting/executive", element: <AcctExecutivePage /> },
  { path: "/accounting/accounts", element: <AcctAccountsPage /> },
  { path: "/accounting/periods", element: <AcctPeriodsPage /> },
  { path: "/accounting/trial-balance", element: <AcctTrialBalancePage /> },
  { path: "/accounting/perms", element: <AcctPermsPage /> },
  { path: "/accounting/audit", element: <AcctAuditPage /> },
  { path: "/accounting/settings", element: <AcctSettingsPage /> },
];

// قوقعة أب واحدة (AcctLayout) تحمل AppShell + التبويبات — تبقى مثبّتة عبر Outlet.
// كل صفحة تعرض فقط محتواها، فلا تُعاد بناء التبويبات عند التنقّل بينها.
export const accountingRoutes = [(
  <Route
    key="acct-parent"
    element={
      <ProtectedRoute roles={MANAGER_ROLES}>
        <FeatureGate feature="accounting"><AcctLayout /></FeatureGate>
      </ProtectedRoute>
    }
  >
    {PAGES.map(({ path, element }) => (
      <Route key={path} path={path} element={element} />
    ))}
  </Route>
)];
